import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import useNotificatioMarkRead from './services/hooks/useNotificationMarkRead'
import useNotificationList from './services/hooks/useNotificationList'
import Loader from '../../components/Loader'
import StyledBgContainer from '../../components/StyledBgContainer/StyledBgContainer'
import {
  NotificationData,
  Notifications,
} from './services/types/APIResponseType'
import Path from '../../router/localRoutes'
import { formatTime, getDateTitle } from '../../utils'
import './Notification.css'
import { useWebSocket } from '../../context/WebSocketContext'

const Notification = () => {
  const [page, setPage] = useState(1)
  const [notificationData, setNotificationData] = useState<Notifications[]>([])
  const [hasMore, setHasMore] = useState(true)
  const [count, setCount] = useState(0)
  const limit = 5
  const loaderRef = useRef<HTMLDivElement | null>(null)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [errorMsg, setErrorMsg] = useState<string>('')
  const { socket } = useWebSocket()

  const { data: notificationList, isLoading } = useNotificationList(
    page,
    limit,
    count,
  )
  const { mutate: notificationMarkRead } = useNotificatioMarkRead()

  const navigate = useNavigate()

  const handleBack = () => {
    markRead()
    navigate(Path.AdminDashboard)
  }

  useEffect(() => {
    const handleScroll = () => {
      if (loaderRef.current) {
        const { bottom } = loaderRef.current.getBoundingClientRect()
        if (bottom <= window.innerHeight && !isLoadingMore && hasMore) {
          setIsLoadingMore(true)
          setPage((prevPage) => prevPage + 1)
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isLoadingMore, hasMore])

  const markRead = () => {
    notificationMarkRead({
      onSuccess: () => {},
      onError: (error: { message: React.SetStateAction<string> }) => {
        setErrorMsg(error.message)
      },
    })
  }

  useEffect(() => {
    if (notificationList && notificationList.data.notifications.length > 0) {
      setNotificationData((prev: Notifications[]) => {
        return [...prev, ...notificationList.data.notifications]
      })
      setIsLoadingMore(false)
    }
    if (
      notificationList &&
      notificationList.data.notifications.length < limit
    ) {
      setHasMore(false)
    }
  }, [notificationList, count])

  useEffect(() => {
    if (socket) {
      const handleNotification = (data: { count: number }) => {
        setCount(data.count)
      }

      socket.on('bell-badge-notification', handleNotification)

      return () => {
        socket.off('bell-badge-notification', handleNotification)
      }
    }
  }, [socket, count])

  return (
    <StyledBgContainer>
      <div className="notification-wrapper">
        <div className="notification-top">
          <img
            src="/icon/Arrow left.svg"
            onClick={handleBack}
            alt="back button"
          />
          <label>Notifications</label>
          <label></label>
        </div>

        <div className="notification-main-content-wrapper">
          <p className="text-red-600">{errorMsg}</p>

          {isLoading && !isLoadingMore ? (
            <Loader />
          ) : (
            notificationData?.map(
              (notificationDate: Notifications, index: number) => {
                const dateTitle = getDateTitle(notificationDate.title)
                if (notificationDate.data.length > 0) {
                  return (
                    <div
                      key={index}
                      ref={
                        index === notificationData.length - 1 && !isLoadingMore
                          ? loaderRef
                          : null
                      }
                    >
                      <h3>{dateTitle}</h3>
                      {notificationDate?.data?.length > 0 &&
                        notificationDate?.data?.map(
                          (data: NotificationData, itemIndex: number) => (
                            <>
                              <div
                                key={itemIndex}
                                className="cursor-pointer notification-content-wrapper"
                                onClick={() => {
                                  if (
                                    data.notificationType === 'GROUP_MESSAGE'
                                  ) {
                                    navigate(
                                      `${Path.AdminDashboard}?tab=group-chat`,
                                    )
                                  } else if (
                                    data.notificationType ===
                                    'FACE_AUTHENTICATION_FAILED'
                                  ) {
                                    navigate(
                                      `${Path.AdminDashboard}?tab=random-check-ins`,
                                    )
                                  }
                                }}
                              >
                                <img src="/icon/bell white icon.png" alt="" />
                                <p>{data.message}</p>
                                <label>{formatTime(data.createdAt)}</label>
                              </div>
                              <div className="break_line"></div>
                            </>
                          ),
                        )}
                    </div>
                  )
                } else {
                  return <></>
                }
              },
            )
          )}
          {isLoadingMore && <Loader />}
        </div>
      </div>
    </StyledBgContainer>
  )
}

export default Notification
